type StatCardProps = {
    value: string;
    label: string;
  };
  
  export const StatCard = ({ value, label }: StatCardProps) => {
    return (
      <div>
        <div className="hidden lg:block">
        <div className="items-center grid -gap-1 px-6 py-10 rounded-[28px] h-64 transition backdrop-blur-lg bg-white/30 border-[1.5px] border-white border-solid text-center">
  
        <h3 className="text-[32px] font-semibold text-white">
          {value}
        </h3>
  
        <p className="text-white/80 mt-2 text-[18px]">
          {label}
        </p>
  
      </div>
        </div>

        <div className="block lg:hidden">
        <div className="p-5  rounded-[28px] border-[1px] border-solid border-white backdrop-blur-lg bg-white/30 text-center">
  
        <h3 className="text-[24px] font-semibold text-white">
          {value}
        </h3>
  
        <p className="text-white/80 mt-2 text-[12px]">
          {label}
        </p>
  
      </div>
        </div>
      </div>
      
    );
  };